import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { SpostaDocumentoRequest } from "src/app/common/models/documento/sposta-documento-request";
import { TipoSezione } from "src/app/common/models/tipologiche/tipo-sezione";
import { FormValidationService } from "src/app/common/services/form-validation.service";
import { TipiSezioneConfiguration } from "src/app/core/configuration/tipi-sezione-configuration";
import { HelpersService } from "src/app/core/services/helpers.service";
import { OperationsService } from "src/app/core/services/operations.service";
import { DocumentoAllegato } from "../../../models/documento-allegato";

declare var closeModal: any;
declare var openModal: any;

@Component({
  selector: "[doc_sposta_categoria_modal]",
  templateUrl: "documento-sposta-modal.component.html",
  host: {
    "[class.modal]": "'true'",
    "[class.fade]": "'true'",
    "[attr.role]": "'dialog'",
  },
})
export class DocumentoSpostaCategoriaModal {
  @Output()
  onReturn: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  onSelect: EventEmitter<any> = new EventEmitter<any>();
  @Input()
  entityList: Array<any> = [];
  @Input()
  fascicolo: any;

  documento: DocumentoAllegato;
  sezione: any;
  sezioni: any[] = [];
  idFascicolo: string;
  isMain: boolean;
  esn: string;
  formTitle: string;
  fileUploadedName: string;
  spostaDocumentoForm: FormGroup;
  request: SpostaDocumentoRequest;
  urlUpdate: string = "/rs/ops/gp/documento";

  sezioniOptions: TipoSezione[] = [];
  sezioneFascicolo: any;
  sezioneOptions: TipoSezione = new TipoSezione();

  labelSezioneAdempimenti = "ADEMPIMENTI";
  labelSezioneDocumentazioneFascicolo = "DOCUMENTAZIONE FASCICOLO";
  idTipoSezioneAdempimenti: string = TipiSezioneConfiguration.idTipoSezioneAdempimenti;
  idTipoSezioneDocumentazioneFascicolo: string = TipiSezioneConfiguration.idTipoSezioneDocumentazioneFascicolo;

  constructor(
    protected operationService: OperationsService,
    private campiForm: FormBuilder,
    private helpers: HelpersService,
    private formValidationService: FormValidationService
  ) {}

  initForm(sezione, sezioni, fascicoloId: string, documento) {
    //this.urlUpdate=url;
    // this.sezione = sezione;
    this.idFascicolo = fascicoloId;
    this.documento = documento;
    this.createForm();
    this.populateSelect(sezioni);
    openModal("docSpostaModal");
  }

  // getEntityList(sezione, esn){
  //   let arrayList = [];
  //   for (let idDescrittore of IdDescrittoriDiSezione.TutteLeSezioni) {
  //     if (idDescrittore.esn === esn) {
  //       arrayList = sezione[idDescrittore.nomeCampoEntityList];
  //     }
  //   }
  //   return arrayList;
  // }

  populateSelect(sezioni: any[]) {
    console.log(sezioni);

    this.sezioni = sezioni;
    this.sezioniOptions = [];
    //filtro solo le sezioni già popolate
    sezioni
      .filter(
        (element) =>
          element.entities === true ||
          element.esn === "SezioneDocumentazioneAllegata"
      )
      .forEach((element) => {
        this.sezioneOptions = new TipoSezione();
        Object.assign(this.sezioneOptions, element.tipoSezione);
        this.sezioneOptions.label = element.nomeSezione;
        if (
          element.documenti.length === 0 ||
          !element.documenti.find((el) => el.id === this.documento.id)
        ) {
          this.sezioniOptions.push(this.sezioneOptions);
        } else {
          this.request.tipoSezioneSorgente = element.tipoSezione;
        }
      });
  }

  createForm() {
    this.request = new SpostaDocumentoRequest();
    this.request.idDocumento = this.documento.id;
    //  this.request.idFascicolo = this.idFascicolo;
    this.spostaDocumentoForm = this.campiForm.group({
      sezione: [
        this.request.tipoSezioneDestinazione
          ? this.request.tipoSezioneDestinazione
          : null,
      ],
    });
  }

  // getIdSezione():string{
  //   let id ='';
  //   this.sezioni.forEach(element => {
  //     if(element.tipoSezione.id === this.request.tipoSezioneDestinazione.id){
  //       id=element.id;
  //     }
  //   });
  //   return id;
  // }

  getDestinazione(event){
    this.sezioni
      .filter(
        (element) =>
          element.entities === true ||
          element.esn === "SezioneDocumentazioneAllegata"
      )
      .forEach((element) => {
        if(element.tipoSezione.id === event.id){
          this.request.tipoSezioneDestinazione = element.tipoSezione;
        }
      });
  }

  update() {
    let sezioneDoc = this.sezioni.find(
      (el) =>
        el.tipoSezione &&
        el.tipoSezione.id === this.request.tipoSezioneDestinazione.id
    );
    let formTitle = "Sposta documento - " + sezioneDoc.nomeSezione;
    this.onSelect.emit({
      request: this.request,
      sezione: sezioneDoc,
      formTitle: formTitle,
    });
  }

  manageModal(response) {
    if (response.returnCode === "OK") {
      closeModal("docSpostaModal");
      this.onReturn.emit(response);
    }
  }
}
